module.exports = __webpack_public_path__ + "img/bg1.08f3c538.08f3c538.png";